import { render, staticRenderFns } from "./ImageCollectionItem.vue?vue&type=template&id=7e1a66a4&lang=html"
import script from "./ImageCollectionItem.vue?vue&type=script&lang=js"
export * from "./ImageCollectionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports